/**
 * Стена на 2D-чертеже.
 *
 * Рисуется многоугольником, а не толстой линией: контур приходит уже с
 * подрезанными стыками (см. lib/wallPolygons), поэтому углы получаются
 * цельными при любой толщине и любом угле между стенами.
 *
 * Заливку задаёт виджет — на чертеже это штриховка под 45°, как в
 * строительной документации, а не сплошной цвет.
 */
import type { PointerEvent } from "react";
import type { Pt } from "@/shared/lib/geometry";

interface Props {
	/** Контур стены с учётом стыков */
	outline: Pt[];
	/** Заливка: обычно ссылка на pattern со штриховкой */
	fill: string;
	stroke: string;
	strokeWidth: number;
	cursor: string;
	onPointerDown: (e: PointerEvent<SVGPolygonElement>) => void;
	/** Id стены — по нему ластик знает, что удалять */
	id: string;
}

export const WallShape = ({
	id,
	outline,
	fill,
	stroke,
	strokeWidth,
	cursor,
	onPointerDown,
}: Props) => {
	return (
		<polygon
			data-role="wall"
			data-id={id}
			points={outline.map((p) => `${p.x},${p.y}`).join(" ")}
			fill={fill}
			stroke={stroke}
			strokeWidth={strokeWidth}
			strokeLinejoin="miter"
			style={{ cursor }}
			onPointerDown={onPointerDown}
		/>
	);
};
